import { BiCheckCircle, BiCircle, BiFastForward } from "react-icons/bi";
import { Flex } from "@chakra-ui/react";
import {
  StepContainer,
  StepItem,
  StepItemIcon,
  StepItemSelectedIndicator,
  StepItemText,
} from "./CustomStepperComponents";

export interface CustomStepperProps {
  stepList?: string[];
  activeStep: number;
  completedSteps: number[];
  skippedSteps: number[];
  onStepClick: (index: number) => void;
}

const CustomStepper = ({
  stepList,
  activeStep,
  completedSteps,
  skippedSteps,
  onStepClick,
}: CustomStepperProps) => {
  function getCurrentStepElement(index: number, text: string) {
    const amBlue = "#5e8ab4";
    const isCompleted = completedSteps.find((e) => e === index) === index;
    const isSkipped = skippedSteps.find((e) => e === index) === index;
    const isActive = index === activeStep;
    const highlightColor = (isActive || isCompleted || isSkipped) && amBlue || "";
    const textDecoration = isSkipped && "line-through" || "";

    const icon = () => {
      if (isActive) {
        return <BiCircle key={index.toString()} color={highlightColor} />
      } else if (isCompleted) {
        return <BiCheckCircle key={index.toString()} color={highlightColor} />
      } else if (isSkipped) {
        return <BiFastForward key={index.toString()} color={amBlue} />
      } else {
        return <BiCircle />
      }
    }

    return (
      <>
        {index === activeStep && <StepItemSelectedIndicator />}
        <StepItemIcon>
            {icon()}
        </StepItemIcon>
        <StepItemText color={highlightColor} textDecoration={textDecoration}>
          {text}
        </StepItemText>
      </>
    )
  }

  return (
    <Flex>
      <StepContainer color="currentColor">
        {stepList?.map((item, index) => (
          <StepItem
            key={index}
            onClick={() => onStepClick?.(index)}
            // TO DO: Uncomment this once the scroll to section functionality is fully baked.
            // cursor="pointer"
          >
            {getCurrentStepElement(index, item)}
          </StepItem>
        ))}
      </StepContainer>
    </Flex>
  );
}

export default CustomStepper;